<template>
  <xl-table-popover :value="getFieldValue" :styleInfo="JSON.stringify(styleInfo)" :sourceType="params.sourceType" />
</template>

<script setup>
import { ref, watchEffect, onUnmounted } from 'vue';
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
});

const getParams = ref(null);
const getFieldValue = ref();
const styleInfo = ref([]);

const getRandomColor = (index) => {
  const colors = ['#fce3e2', '#fce7cc', '#f8edc0', '#e3f09f', '#d3f5cd', '#c9f2ec', '#ceeffd', '#e1e9ff', '#fce2f2', '#eee6ff']; // 示例色值数组
  return colors[index % colors.length];
};
const stopWatch = watchEffect(() => {
  getParams.value = JSON.parse(JSON.stringify(props.params));
  getFieldValue.value =
    getParams.value?.fieldValue && Array.isArray(getParams.value?.fieldValue)
      ? getParams.value?.fieldValue
          ?.map((item) => {
            return item?.name || item?.departmentName;
          })
          .join(',')
      : '';

  getFieldValue.value.split(',').forEach((cItem, index) => {
    styleInfo.value.push({
      label: cItem,
      background: getRandomColor(index)
    });
  });
});
onUnmounted(() => {
  stopWatch();
});
</script>
<style scoped lang="less">
@import './depart.less';
</style>
